<!-- Loading bar -->
<loading-bar></loading-bar>

<!-- Navigation -->
<vertical-navigation
    class="dark bg-[#1A1A1A] print:hidden"
    [appearance]="isThinMode ? 'thin' : 'default'"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="isThinMode ? navigation.compact : navigation.default"
    [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container verticalNavigationHeader>
        <ng-content select="[asideHeader]"></ng-content>
    </ng-container>

    <!-- Navigation content header hook -->
    <ng-container verticalNavigationContentHeader>
        <ng-content select="[asideContentHeader]"></ng-content>
    </ng-container>
    
    <!-- Navigation footer hook -->
    <ng-container verticalNavigationFooter>
        <ng-content select="[asideFooter]"></ng-content>
    </ng-container>
</vertical-navigation>

<!-- Right column — header + content -->
<div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Dark header — continues the sidebar's visual language -->
    <header></header>

    <!-- Content wrapper — rounded top-left creates a smooth transition from dark to light -->
    <div class="flex-1 flex flex-col min-h-0 bg-[#f8f9fb] rounded-tl-2xl overflow-hidden shadow-[-4px_-2px_24px_-12px_rgba(0,0,0,0.08)]">
        <!-- Content — slight top spacing below navbar -->
        <div class="flex-1 px-4 md:px-6 pt-4 overflow-auto">
            <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
                 Otherwise, layout changes won't be registered and the view won't be updated! -->
            <router-outlet *ngIf="true"></router-outlet>
        </div>
    </div>

</div>
